module.exports = __webpack_public_path__ + "bee20fdf95c809b294cd17cb4f526324.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/retro-gaming-system.png
// module id = 2723
// module chunks = 0